import SEO from "../components/SEO";
import ProgramsSection from "../components/Programs";

export default function Programs() {
  return (
    <>
      <SEO
        title="Programs | Jisedai"
        description="Explore Jisedai bootcamps, workshops, hackathons, and research-driven learning programs."
        url="https://www.jisedai.africa/programs"
      />
      <ProgramsSection />
    </>
  );
}
